import { render, staticRenderFns } from "./SearchBannerImageSkeleton.vue?vue&type=template&id=f0f0274a&"
import script from "./SearchBannerImageSkeleton.vue?vue&type=script&lang=ts&"
export * from "./SearchBannerImageSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0f0274a')) {
      api.createRecord('f0f0274a', component.options)
    } else {
      api.reload('f0f0274a', component.options)
    }
    module.hot.accept("./SearchBannerImageSkeleton.vue?vue&type=template&id=f0f0274a&", function () {
      api.rerender('f0f0274a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/components/banner/skeletons/SearchBannerImageSkeleton.vue"
export default component.exports